import {
    login,
    logout,
    getUserInfo
} from '@/api/sys-user'
import { resTree } from '@/api/sys-res'
import { deepTraverse } from 'es-sharp'
import {
    setToken,
    getMenuByRouter,
    getHomeRoute,
    getUserAvatar
} from '@/utils/helper'
import { lsGlobalSet } from '@/utils/ls'
import defaultAvatar from '@/assets/images/defaultAvatar.jpg'

// add user module
export default function(Vue, options = {}) {
    var {
        state = {}, store, config
    } = options

    // check
    if (!store) {
        throw new Error("必需先创建store实例")
    }

    // 注册store.user模块
    store.registerModule('user', {
        state: {
            info: {
                id: "",
                nickname: "",
            },
            ...state,
            hasGetUserInfo: false, // 会话标识
            access: "", // 用户权限
            homeRoute: null, // 主页
            routes: [], // 静态路由
            namedRoutes: [], // 静态命名路由
        },

        getters: {
            menuList: (state, getters, rootState) => {
                return getMenuByRouter(getters.allRoutes, state.access)
            },

            menuMap: (state, getters) => {
                var map = {}

                deepTraverse(getters.menuList, (route, parent) => {
                    map[route.name] = true
                })

                return map
            },

            allRoutes: (state, getters, rootState) => {
                var routes = state.routes

                // ivux-resource 动态路由
                if (rootState.resource) {
                    routes = routes.concat(rootState.resource.routes)
                }

                return routes
            },

            allNamedRoutes: (state, getters, rootState) => {
                var namedRoutes = Object.assign({}, state.namedRoutes)

                // // ivux-resource 动态路由
                if (rootState.resource) {
                    Object.assign(namedRoutes, rootState.resource.namedRoutes)
                }

                return namedRoutes
            },

            // 获取直系路由数组
            getRelativeRoutes: (state, getters, rootState, rootGetters) => (route) => {
                return rootGetters['resource/getRelativeRoutes'](route, getters.allNamedRoutes)
            },

            // 获取菜单层级路由
            getOpenedMenuList: (state, getters) => (route) => {
                var opened = getters.getRelativeRoutes(route)
                    .filter(v => getters.menuMap[v.name])

                return opened
            },
        },

        mutations: {
            // 设置用户基本信息
            setUserInfo(state, userInfo) {
                Object.assign(state.info, userInfo)

                lsGlobalSet("user", state.info)
                state.hasGetUserInfo = true

                // 用户默认头像
                state.info.avatar = getUserAvatar(state.info.avatar)
            },

            // 设置用户权限
            setAccess(state, resTree) {
                var auth = resTree.filter(v => !!v.uri)

                state.auth = auth
                state.access = auth.map(v => v.uri)
            },

            // 清理用户信息
            clearUser(state) {
                Object.keys(state.info).forEach(k => state.info[k] = "")

                setToken('')
                lsGlobalSet("user", '')
                state.hasGetUserInfo = false
            },

            // 添加静态路由
            addRoutes(state, routes) {
                state.routes.push(...routes)

                deepTraverse(routes, (route, parent) => {
                    if (route.name) {
                        state.namedRoutes[route.name] = route
                    }

                    if (route.meta && !route.meta.parentName && parent) {
                        // 若parent.name不存在，则这是一个管道路由，将其视为透明
                        route.meta.parentName = parent.name ? parent.name :
                            parent.meta && parent.meta.parentName ? parent.meta.parentName : ''
                    }
                })
            },

            // 设置主页路由
            setHomeRoute(state, homeRoute) {
                state.homeRoute = homeRoute
            },
        },

        actions: {
            // 登录
            handleLogin({
                commit
            }, payload) {
                return login(payload)
                    .then(res => {
                        const data = res.data

                        // 记忆登录状态
                        if (process.env.VUE_APP_IDENTITY_AUTH == "token") {
                            setToken(data.token)
                        }

                        if (process.env.VUE_APP_IDENTITY_AUTH == "session") {
                            setToken(new Date().getTime())
                            // 记录用户个人信息
                            commit('setUserInfo', res.data.user)
                        }
                    })
            },

            // 退出登录
            handleLogOut({
                state,
                commit
            }, payload) {
                return logout(payload)
                    .then(res => {
                        // 清理信息
                        return commit('clearUser')
                    })
            },

            // 获取用户相关信息
            getUserInfo({
                state,
                commit,
                dispatch
            }, payload) {
                return getUserInfo(payload)
                    .then(res => {
                        // 记录用户个人信息
                        commit('setUserInfo', res.data.info || res.data.user || res.data.passport)
                    })
            },

            // 获取资源权限
            getResAccess({
                state,
                commit,
                dispatch
            }) {
                return resTree(state.info.id)
                    .then(res => {
                        // 设置用户权限
                        commit("setAccess", res.data.list)
                        // 加载资源
                        commit("resource/setRes", res.data.list)
                    })
            }
        }
    })

    // 配套混入
    Vue.mixin({
        computed: {
            $user() {
                return this.$store.state.user.info
            },
        },
    })

    // 静态路由状态初始化
    if (config.routes) {
        // 设置静态路由
        store.commit("addRoutes", config.routes)
        // 设置静态主页
        store.commit('setHomeRoute', getHomeRoute(config.routes))
    }
}